// extracted by mini-css-extract-plugin
module.exports = {"createDialog":"createDialog--2KFu1","more":"more--2CNsQ","switchLabel":"switchLabel--2Gl-A"};